import { apiClient } from 'v4/core/apiClient';
import { createDashboardApi } from './dashboard.api.http';

export const myDashboardApi = createDashboardApi(apiClient);
